import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=ddad86b6&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddad86b6')) {
      api.createRecord('ddad86b6', component.options)
    } else {
      api.reload('ddad86b6', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=ddad86b6&", function () {
      api.rerender('ddad86b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26WBwGMG1Yaxw/JS/videoIframe.vue"
export default component.exports